import { render, staticRenderFns } from "./TaskPlan.vue?vue&type=template&id=924f135a&scoped=true&"
import script from "./TaskPlan.vue?vue&type=script&lang=js&"
export * from "./TaskPlan.vue?vue&type=script&lang=js&"
import style0 from "./TaskPlan.vue?vue&type=style&index=0&id=924f135a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "924f135a",
  null
  
)

export default component.exports